import { ref, Ref } from "vue";

// 0 Ended
// 1 Started
export const gameStatus: Ref<number> = ref(0);